// extracted by mini-css-extract-plugin
export default {"container":"About_container__iVhcl","left":"About_left__xrjuG","right":"About_right__95Z1S"};